/* eslint-disable */

import React, { useState } from 'react'
import { DialogClose } from '../../Components/ui/dialog'
import env from '../../env/env'
import { useModal } from '../../hooks/use-modal-store'
import { useNavigate } from 'react-router-dom'
import { Skeleton } from '../ui/skeleton'
import FullPagePopupLayout from './FullPagePopupLayout'

const BasketLoadingState = () => (
  <div className='fabits-basket-popup-card'>
    <div className='flex items-center space-x-4'>
      <Skeleton className='h-12 w-12 rounded-lg' />
      <div className='space-y-2'>
        <Skeleton className='h-4 w-[200px]' />
        <Skeleton className='h-4 w-[100px]' />
      </div>
    </div>
    <Skeleton className='h-4 mt-2 w-[100px]' />
  </div>
)

const BasketRows = ({
  basketDetails,
  expandedBaskets,
  toggleBasketExpansion,
  tone = 'success',
}) => {
  if (!basketDetails) return null

  return (
    <div className='fabits-basket-popup-list'>
      {Object.entries(basketDetails).map(([basketKey, basketItems]) => {
        const failedCount = basketItems.filter((item) => item.status === 'FAILED').length
        const firstItem = basketItems[0]
        const isAlert = tone !== 'success'

        return (
          <div
            key={basketKey}
            className={`fabits-basket-popup-card ${
              isAlert ? 'fabits-basket-popup-card-alert' : ''
            }`}
          >
            <div
              className={`fabits-basket-popup-card-head ${
                expandedBaskets[basketKey] ? 'is-expanded' : ''
              }`}
            >
              <img
                src={`${env.SVGS}/basket.svg`}
                alt=''
                aria-hidden='true'
                className='fabits-basket-popup-card-icon'
              />

              <div>
                {firstItem?.customerBasketName && (
                  <p className='fabits-basket-popup-card-title'>{firstItem?.customerBasketName}</p>
                )}
                {firstItem?.status && (
                  <p className='fabits-basket-popup-card-status'>
                    {tone === 'partial'
                      ? `(${failedCount}/${basketItems.length}) Unsuccessful`
                      : firstItem?.status}
                  </p>
                )}
              </div>
            </div>

            {expandedBaskets[basketKey] && (
              <div className='fabits-basket-popup-fund-list'>
                {basketItems.map((fund, index) => {
                  const fundAlert = fund.status !== 'SUCCESS'
                  return (
                    <div
                      key={fund.id || index}
                      className={`fabits-basket-popup-fund ${
                        fundAlert ? 'fabits-basket-popup-fund-alert' : ''
                      }`}
                    >
                      <img
                        src={`${env.SVGS}/basket.svg`}
                        alt=''
                        aria-hidden='true'
                        className='fabits-basket-popup-card-icon'
                      />
                      <div>
                        <p className='fabits-basket-popup-fund-title'>
                          {fund?.schemeName ? fund?.schemeName : fund?.legalName}
                        </p>
                        <p className='fabits-basket-popup-card-status'>{fund?.status}</p>
                      </div>
                    </div>
                  )
                })}
              </div>
            )}

            <button
              type='button'
              className='fabits-basket-popup-show-more'
              onClick={() => toggleBasketExpansion(basketKey)}
            >
              {expandedBaskets[basketKey] ? 'Show less' : 'Show more'}
            </button>
          </div>
        )
      })}
    </div>
  )
}

const SuccessPopup = ({ isModalOpen, onClose, baskets }) => {
  const [expandedBaskets, setExpandedBaskets] = useState({})
  const navigate = useNavigate()

  const toggleBasketExpansion = (basketKey) => {
    setExpandedBaskets((prev) => ({
      ...prev,
      [basketKey]: !prev[basketKey],
    }))
  }

  return (
    <FullPagePopupLayout
      isOpen={isModalOpen}
      onClose={onClose}
      severity='success'
      title='Basket Order Successful'
      bodyClassName='fabits-basket-popup-body'
      actions={
        <>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-secondary'
            onClick={() => {
              onClose(), navigate('/dashboard/mutual-funds/orders')
            }}
          >
            Order History
          </button>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-primary'
            onClick={() => {
              onClose(), navigate('/dashboard/plans')
            }}
          >
            Explore More
          </button>
        </>
      }
    >
      {baskets ? (
        <BasketRows
          basketDetails={baskets}
          expandedBaskets={expandedBaskets}
          toggleBasketExpansion={toggleBasketExpansion}
          tone='success'
        />
      ) : (
        <BasketLoadingState />
      )}
    </FullPagePopupLayout>
  )
}

const FailedPopup = ({ isModalOpen, onClose, baskets }) => {
  const [expandedBaskets, setExpandedBaskets] = useState({})

  const toggleBasketExpansion = (basketKey) => {
    setExpandedBaskets((prev) => ({
      ...prev,
      [basketKey]: !prev[basketKey],
    }))
  }

  return (
    <FullPagePopupLayout
      isOpen={isModalOpen}
      onClose={onClose}
      severity='error'
      title='Basket Order Failed'
      bodyClassName='fabits-basket-popup-body'
      actions={
        <>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-secondary'
          >
            Retry
          </button>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-primary'
          >
            Get Help
          </button>
        </>
      }
    >
      {baskets && (
        <BasketRows
          basketDetails={baskets}
          expandedBaskets={expandedBaskets}
          toggleBasketExpansion={toggleBasketExpansion}
          tone='error'
        />
      )}
    </FullPagePopupLayout>
  )
}

const PartialPopup = ({ isModalOpen, onClose, baskets }) => {
  const [expandedBaskets, setExpandedBaskets] = useState({})

  const toggleBasketExpansion = (basketKey) => {
    setExpandedBaskets((prev) => ({
      ...prev,
      [basketKey]: !prev[basketKey],
    }))
  }

  const statusCount =
    baskets &&
    Object.values(baskets)
      .flat()
      .reduce(
        (acc, item) => {
          if (item.status === 'SUCCESS') {
            acc.success += 1
          } else if (item.status === 'FAILED') {
            acc.failed += 1
          }
          return acc
        },
        { success: 0, failed: 0 },
      )

  return (
    <FullPagePopupLayout
      isOpen={isModalOpen}
      onClose={onClose}
      severity='partial'
      title={`Partial Order Successful (${statusCount?.failed}/${
        statusCount?.failed + statusCount?.success
      })`}
      bodyClassName='fabits-basket-popup-body'
      actions={
        <>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-secondary'
            onClick={onClose}
          >
            Close
          </button>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-primary'
          >
            Get Help
          </button>
        </>
      }
    >
      {baskets && (
        <BasketRows
          basketDetails={baskets}
          expandedBaskets={expandedBaskets}
          toggleBasketExpansion={toggleBasketExpansion}
          tone='partial'
        />
      )}
    </FullPagePopupLayout>
  )
}

const SipSuccess = ({ isModalOpen, onClose, data }) => {
  const navigate = useNavigate()

  return (
    <FullPagePopupLayout
      isOpen={isModalOpen}
      onClose={onClose}
      severity={data?.severity}
      title={data?.title || 'SIP order placed'}
      message={data?.message}
      actions={
        <>
          <DialogClose asChild>
            <button
              type='button'
              className='fabits-global-popup-button fabits-global-popup-button-secondary'
              onClick={() => {
                onClose(), navigate('dashboard/plans')
              }}
            >
              Close
            </button>
          </DialogClose>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-primary'
            onClick={() => {
              onClose(), navigate('dashboard/plans')
            }}
          >
            Explore More
          </button>
        </>
      }
    />
  )
}

const BasketOrderPopup = () => {
  const { isOpen, onClose, type, data } = useModal()
  const isModalOpen = isOpen && type === 'openBasketPopup'

  return (
    <>
      {data?.severity === 'sipsuccess' && (
        <SipSuccess isModalOpen={isModalOpen} onClose={onClose} data={data} />
      )}

      {data?.severity === 'success' && (
        <SuccessPopup isModalOpen={isModalOpen} onClose={onClose} baskets={data?.baskets} />
      )}

      {data?.severity === 'error' && (
        <FailedPopup isModalOpen={isModalOpen} onClose={onClose} baskets={data?.baskets} />
      )}

      {data?.severity !== 'sipsuccess' &&
        data?.severity !== 'success' &&
        data?.severity !== 'error' && (
          <PartialPopup isModalOpen={isModalOpen} onClose={onClose} baskets={data?.baskets} />
        )}
    </>
  )
}

export default BasketOrderPopup
